import {
  SIGNUP_USER_REQUEST,
  SIGNIN_USER_REQUEST,
  AUTH_TOKEN_SET,
  AUTH_USER_SUCCESS,
  AUTH_REDIRECT_SET,
  AUTH_LOGOUT,
} from '../types';
import Api from '../../utils/api';
import {
  API_USER_SIGN_UP,
  API_USER_SIGN_IN,
  API_USER_FORGOT_PASSWORD,
  API_USER_CHECK_RESET_PASSWORD,
  API_USER_RESET_PASSWORD,
} from '../../configs/apis';
import {appId} from '../../store';
import {showSavingOnButton, hideSavingOnButton} from '../../components/common/Loaders/ButtonLoader';
import {handleError, resetError} from '../error';

import {getThirdLevelSubdomain, forwardTo} from '../../utils';

const GAME_LABEL = process.env.NODE_ENV === 'production' ? getThirdLevelSubdomain() : 'test-game';

export function setAuthRedirect(path) {
  return {
    type: AUTH_REDIRECT_SET,
    path,
  };
}

export function signUpRequest(params) {
  return async (dispatch) => {
    try {
      dispatch(resetError());
      dispatch({type: SIGNUP_USER_REQUEST, ...params});
      dispatch(showSavingOnButton());
      const queryParams = {...params, label: GAME_LABEL};
      const response = await Api.post(API_USER_SIGN_UP, queryParams);
      const {token} = response;
      dispatch({type: AUTH_TOKEN_SET, token});
      return forwardTo('/complete-profile');
    } catch (error) {
      return dispatch(handleError(error));
    } finally {
      dispatch(hideSavingOnButton());
    }
  };
}

export function signInRequest(params) {
  return async (dispatch, getState) => {
    try {
      const {auth: {redirectAfterLogin = '/lobby'}} = getState();
      dispatch(resetError());
      dispatch({type: SIGNIN_USER_REQUEST, ...params});
      dispatch(showSavingOnButton());
      const queryParams = {...params, label: GAME_LABEL};
      const response = await Api.post(API_USER_SIGN_IN, queryParams);
      const {token} = response;
      dispatch({type: AUTH_TOKEN_SET, token});
      forwardTo(redirectAfterLogin);
      return dispatch({type: AUTH_USER_SUCCESS});
    } catch (error) {
      return dispatch(handleError(error));
    } finally {
      dispatch(hideSavingOnButton());
    }
  };
}

export function forgotPasswordRequest(params) {
  return async (dispatch) => {
    try {
      await Api.post(API_USER_FORGOT_PASSWORD, {...params, appId, label: GAME_LABEL});
      return forwardTo('/sign-in');
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function checkResetPassword(params) {
  return async (dispatch) => {
    try {
      return await Api.post(API_USER_CHECK_RESET_PASSWORD, params);
    } catch (error) {
      forwardTo('/sign-in');
      return dispatch(handleError(error));
    }
  };
}

export function resetPassword(params) {
  return async (dispatch) => {
    try {
      await Api.post(API_USER_RESET_PASSWORD, params);
      return forwardTo('/sign-in');
    } catch (error) {
      return dispatch(handleError(error));
    }
  };
}

export function logOut() {
  return {
    type: AUTH_LOGOUT,
  };
}
